var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 11.569 11.569",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-my-location",
    "data-name": "Icon material-my-location",
    d: "M7.284,5.181a2.1,2.1,0,1,0,2.1,2.1A2.1,2.1,0,0,0,7.284,5.181Zm4.7,1.578A4.73,4.73,0,0,0,7.81,2.583V1.5H6.759V2.583A4.73,4.73,0,0,0,2.583,6.759H1.5V7.81H2.583a4.73,4.73,0,0,0,4.175,4.175v1.083H7.81V11.986A4.73,4.73,0,0,0,11.986,7.81h1.083V6.759Zm-4.7,4.207a3.681,3.681,0,1,1,3.681-3.681A3.678,3.678,0,0,1,7.284,10.966Z",
    transform: "translate(-1.5 -1.5)",
    fill: "#716f6f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationTarget);
export default __webpack_public_path__ + "static/media/location-target.e21ac5851c8d9cadede4a10a17b728ae.svg";
export { ForwardRef as ReactComponent };